<template>
  <div class="cert-page">
    <van-nav-bar
      title="预览结清证明"
      left-arrow
      safe-area-inset-top
      @click-left="$router.go(-1)"
    />

    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="cert" class="paper">
      <h1 class="title">{{ cert.title }}</h1>
      <p class="statement">{{ cert.statement }}</p>

      <table class="table">
        <thead>
          <tr>
            <th>姓名</th>
            <th>身份证号</th>
            <th>业务编号</th>
            <th>借款金额(元)</th>
            <th>贷款发放日</th>
            <th>贷款结清日</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ cert.borrowerName }}</td>
            <td>{{ cert.idNoMasked }}</td>
            <td class="no">{{ cert.businessNo }}</td>
            <td>{{ cert.loanAmountText }}</td>
            <td>{{ cert.issueDate }}</td>
            <td>{{ cert.settleDate }}</td>
          </tr>
        </tbody>
      </table>

      <p class="hereby">特此证明。</p>

      <div class="sign">
        <div class="org-line">
          <span>{{ cert.lenderName }}（盖章）</span>
          <company-seal class="seal" :size="118" />
        </div>
        <div class="date">{{ cert.certifyDate }}</div>
      </div>
    </div>
    <div v-else class="empty">暂无结清证明</div>
  </div>
</template>

<script>
import { settlementCert } from '@/api/request'
import CompanySeal from '@/components/CompanySeal.vue'

export default {
  name: 'SettleCert',
  components: { CompanySeal },
  data() {
    return {
      loading: false,
      cert: null
    }
  },
  methods: {
    async load() {
      const id = this.$route.params.id
      if (!id) return
      this.loading = true
      try {
        const res = await settlementCert(id)
        this.cert = res.data
      } catch (e) {
        this.cert = null
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style lang="less" scoped>
.cert-page {
  min-height: 100%;
  background: #eef1f5;
  padding-bottom: 30px;
}
.van-nav-bar {
  background: #f5f5f5;
  /deep/ .van-nav-bar__title {
    color: #333;
    font-weight: 600;
  }
}
.loading,
.empty {
  text-align: center;
  color: #999;
  padding: 60px 0;
}
.paper {
  margin: 12px;
  background: #fff;
  border-radius: 4px;
  padding: 22px 14px 40px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}
.title {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin: 8px 0 18px;
}
.statement {
  font-size: 13px;
  line-height: 1.85;
  color: #333;
  text-indent: 2em;
  margin: 0 0 16px;
}
.table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 10px;
  color: #333;
  th,
  td {
    border: 1px solid #333;
    padding: 8px 4px;
    text-align: center;
    word-break: break-all;
    vertical-align: middle;
  }
  th {
    background: #fafafa;
    font-weight: 600;
  }
  .no {
    font-size: 9px;
  }
}
.hereby {
  margin: 16px 0 0;
  font-size: 14px;
  color: #333;
}
.sign {
  position: relative;
  margin-top: 36px;
  text-align: right;
  padding-right: 8px;
  min-height: 130px;
}
.org-line {
  position: relative;
  display: inline-block;
  font-size: 13px;
  color: #333;
  padding: 28px 70px 28px 0;
  text-align: right;
}
.date {
  margin-top: 4px;
  font-size: 13px;
  color: #333;
}
.seal {
  position: absolute !important;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
